var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "对账单详情",
        visible: _vm.dialogVisible,
        width: "70%",
        "close-on-click-modal": false,
        "custom-class": "bill-detail-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "section" }, [
        _c("div", { staticClass: "section-title" }, [_vm._v("基础信息")]),
        _vm._v(" "),
        _c("div", { staticClass: "info-grid" }, [
          _c("div", { staticClass: "info-row" }, [
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("对账单号：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.detail.billNo)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("对账状态：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value status-success" }, [
                _vm._v(_vm._s(_vm.detail.reconciliationStatus)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-row" }, [
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("商家名称：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.detail.merchantName)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("打款状态：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value status-success" }, [
                _vm._v(_vm._s(_vm.detail.paymentStatus)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-row" }, [
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("商家类型：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.detail.merchantType)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("账单周期：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(
                  _vm._s(_vm.detail.periodStart) +
                    " 至 " +
                    _vm._s(_vm.detail.periodEnd)
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-row" }, [
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("生成时间：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.detail.generateTime)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("创建人：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.detail.creatorName)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-row" }, [
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("商家备注：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.detail.merchantRemark)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("对账备注：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.detail.reconciliationRemark)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-row" }, [
            _c(
              "div",
              { staticClass: "info-item" },
              [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v("商家订单数据："),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.detail.orderDataFile)),
                ]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "download-link",
                    attrs: { type: "text", size: "small" },
                  },
                  [_vm._v("下载")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section" }, [
        _c("div", { staticClass: "section-title" }, [_vm._v("交易信息")]),
        _vm._v(" "),
        _c("div", { staticClass: "info-grid" }, [
          _c("div", { staticClass: "info-row" }, [
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("订单金额：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value text-danger" }, [
                _vm._v("¥" + _vm._s(_vm.detail.orderAmount)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("订单数量：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.detail.orderCount)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-row" }, [
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [
                _vm._v("成交结算金额："),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value text-danger" }, [
                _vm._v("¥" + _vm._s(_vm.detail.settledAmount)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [
                _vm._v("实际结算金额："),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value text-danger" }, [
                _vm._v("¥" + _vm._s(_vm.detail.actualAmount)),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }